// extracted by mini-css-extract-plugin
export var description = "Card-module--description--qOyqx";
export var details = "Card-module--details--ylvs8";
export var expand = "Card-module--expand--qF+IF";
export var fadeText = "Card-module--fadeText--vt1U+";
export var filterHeading = "Card-module--filterHeading--4DNP1";
export var filteredResults = "Card-module--filteredResults--j-9U5";
export var filteredVideo = "Card-module--filteredVideo--COroR";
export var growSpacer = "Card-module--growSpacer--2gqnW";
export var icon = "Card-module--icon--h95+k";
export var image = "Card-module--image--Ov5Cu";
export var left = "Card-module--left--uz9gK";
export var numVideos = "Card-module--numVideos--3+SC3";
export var picture = "Card-module--picture--+n5cO";
export var playIcon = "Card-module--playIcon--h4Iyi";
export var red = "Card-module--red--5sw0z";
export var right = "Card-module--right--f2LHW";
export var root = "Card-module--root--TMg2o";
export var slim = "Card-module--slim--JR75i";
export var smallTitle = "Card-module--smallTitle--u4FGB";
export var spacer = "Card-module--spacer--7O0F6";
export var tags = "Card-module--tags--COX-5";
export var text = "Card-module--text--4RKpI";
export var title = "Card-module--title--ViTRA";
export var trackType = "Card-module--trackType--L9YOf";